/**
 * Lista de países com códigos telefónicos internacionais
 * Ordenada alfabeticamente, com Portugal (351) como primeiro
 */

export const COUNTRIES = [
  { code: '351', name: 'Portugal', flag: '🇵🇹' },
  { code: '93', name: 'Afeganistão', flag: '🇦🇫' },
  { code: '355', name: 'Albânia', flag: '🇦🇱' },
  { code: '213', name: 'Argélia', flag: '🇩🇿' },
  { code: '376', name: 'Andorra', flag: '🇦🇩' },
  { code: '244', name: 'Angola', flag: '🇦🇴' },
  { code: '54', name: 'Argentina', flag: '🇦🇷' },
  { code: '374', name: 'Arménia', flag: '🇦🇲' },
  { code: '61', name: 'Austrália', flag: '🇦🇺' },
  { code: '43', name: 'Áustria', flag: '🇦🇹' },
  { code: '994', name: 'Azerbaijão', flag: '🇦🇿' },
  { code: '973', name: 'Bahrain', flag: '🇧🇭' },
  { code: '880', name: 'Bangladesh', flag: '🇧🇩' },
  { code: '375', name: 'Bielorrússia', flag: '🇧🇾' },
  { code: '32', name: 'Bélgica', flag: '🇧🇪' },
  { code: '501', name: 'Belize', flag: '🇧🇿' },
  { code: '229', name: 'Benim', flag: '🇧🇯' },
  { code: '975', name: 'Butão', flag: '🇧🇹' },
  { code: '591', name: 'Bolívia', flag: '🇧🇴' },
  { code: '387', name: 'Bósnia e Herzegovina', flag: '🇧🇦' },
  { code: '267', name: 'Botswana', flag: '🇧🇼' },
  { code: '55', name: 'Brasil', flag: '🇧🇷' },
  { code: '673', name: 'Brunei', flag: '🇧🇳' },
  { code: '359', name: 'Bulgária', flag: '🇧🇬' },
  { code: '226', name: 'Burkina Faso', flag: '🇧🇫' },
  { code: '257', name: 'Burundi', flag: '🇧🇮' },
  { code: '855', name: 'Camboja', flag: '🇰🇭' },
  { code: '237', name: 'Camarões', flag: '🇨🇲' },
  { code: '1', name: 'Canadá', flag: '🇨🇦' },
  { code: '238', name: 'Cabo Verde', flag: '🇨🇻' },
  { code: '236', name: 'República Centro-Africana', flag: '🇨🇫' },
  { code: '235', name: 'Chade', flag: '🇹🇩' },
  { code: '56', name: 'Chile', flag: '🇨🇱' },
  { code: '86', name: 'China', flag: '🇨🇳' },
  { code: '57', name: 'Colômbia', flag: '🇨🇴' },
  { code: '269', name: 'Comores', flag: '🇰🇲' },
  { code: '242', name: 'Congo', flag: '🇨🇬' },
  { code: '506', name: 'Costa Rica', flag: '🇨🇷' },
  { code: '385', name: 'Croácia', flag: '🇭🇷' },
  { code: '53', name: 'Cuba', flag: '🇨🇺' },
  { code: '357', name: 'Chipre', flag: '🇨🇾' },
  { code: '420', name: 'República Checa', flag: '🇨🇿' },
  { code: '243', name: 'República Democrática do Congo', flag: '🇨🇩' },
  { code: '45', name: 'Dinamarca', flag: '🇩🇰' },
  { code: '253', name: 'Djibuti', flag: '🇩🇯' },
  { code: '593', name: 'Equador', flag: '🇪🇨' },
  { code: '20', name: 'Egito', flag: '🇪🇬' },
  { code: '503', name: 'El Salvador', flag: '🇸🇻' },
  { code: '240', name: 'Guiné Equatorial', flag: '🇬🇶' },
  { code: '291', name: 'Eritreia', flag: '🇪🇷' },
  { code: '372', name: 'Estónia', flag: '🇪🇪' },
  { code: '251', name: 'Etiópia', flag: '🇪🇹' },
  { code: '679', name: 'Fiji', flag: '🇫🇯' },
  { code: '358', name: 'Finlândia', flag: '🇫🇮' },
  { code: '33', name: 'França', flag: '🇫🇷' },
  { code: '241', name: 'Gabão', flag: '🇬🇦' },
  { code: '220', name: 'Gâmbia', flag: '🇬🇲' },
  { code: '995', name: 'Geórgia', flag: '🇬🇪' },
  { code: '49', name: 'Alemanha', flag: '🇩🇪' },
  { code: '233', name: 'Gana', flag: '🇬🇭' },
  { code: '30', name: 'Grécia', flag: '🇬🇷' },
  { code: '502', name: 'Guatemala', flag: '🇬🇹' },
  { code: '224', name: 'Guiné', flag: '🇬🇳' },
  { code: '245', name: 'Guiné-Bissau', flag: '🇬🇼' },
  { code: '592', name: 'Guiana', flag: '🇬🇾' },
  { code: '509', name: 'Haiti', flag: '🇭🇹' },
  { code: '504', name: 'Honduras', flag: '🇭🇳' },
  { code: '852', name: 'Hong Kong', flag: '🇭🇰' },
  { code: '36', name: 'Hungria', flag: '🇭🇺' },
  { code: '354', name: 'Islândia', flag: '🇮🇸' },
  { code: '91', name: 'Índia', flag: '🇮🇳' },
  { code: '62', name: 'Indonésia', flag: '🇮🇩' },
  { code: '98', name: 'Irão', flag: '🇮🇷' },
  { code: '964', name: 'Iraque', flag: '🇮🇶' },
  { code: '353', name: 'Irlanda', flag: '🇮🇪' },
  { code: '972', name: 'Israel', flag: '🇮🇱' },
  { code: '39', name: 'Itália', flag: '🇮🇹' },
  { code: '225', name: 'Costa do Marfim', flag: '🇨🇮' },
  { code: '81', name: 'Japão', flag: '🇯🇵' },
  { code: '962', name: 'Jordânia', flag: '🇯🇴' },
  { code: '7', name: 'Cazaquistão', flag: '🇰🇿' },
  { code: '254', name: 'Quénia', flag: '🇰🇪' },
  { code: '686', name: 'Kiribati', flag: '🇰🇮' },
  { code: '965', name: 'Kuwait', flag: '🇰🇼' },
  { code: '996', name: 'Quirguistão', flag: '🇰🇬' },
  { code: '856', name: 'Laos', flag: '🇱🇦' },
  { code: '371', name: 'Letónia', flag: '🇱🇻' },
  { code: '961', name: 'Líbano', flag: '🇱🇧' },
  { code: '266', name: 'Lesoto', flag: '🇱🇸' },
  { code: '231', name: 'Libéria', flag: '🇱🇷' },
  { code: '218', name: 'Líbia', flag: '🇱🇾' },
  { code: '423', name: 'Liechtenstein', flag: '🇱🇮' },
  { code: '370', name: 'Lituânia', flag: '🇱🇹' },
  { code: '352', name: 'Luxemburgo', flag: '🇱🇺' },
  { code: '389', name: 'Macedónia do Norte', flag: '🇲🇰' },
  { code: '261', name: 'Madagáscar', flag: '🇲🇬' },
  { code: '265', name: 'Malawi', flag: '🇲🇼' },
  { code: '60', name: 'Malásia', flag: '🇲🇾' },
  { code: '960', name: 'Maldivas', flag: '🇲🇻' },
  { code: '223', name: 'Mali', flag: '🇲🇱' },
  { code: '356', name: 'Malta', flag: '🇲🇹' },
  { code: '692', name: 'Ilhas Marshall', flag: '🇲🇭' },
  { code: '222', name: 'Mauritânia', flag: '🇲🇷' },
  { code: '230', name: 'Maurícia', flag: '🇲🇺' },
  { code: '52', name: 'México', flag: '🇲🇽' },
  { code: '691', name: 'Micronésia', flag: '🇫🇲' },
  { code: '373', name: 'Moldávia', flag: '🇲🇩' },
  { code: '377', name: 'Mónaco', flag: '🇲🇨' },
  { code: '976', name: 'Mongólia', flag: '🇲🇳' },
  { code: '382', name: 'Montenegro', flag: '🇲🇪' },
  { code: '212', name: 'Marrocos', flag: '🇲🇦' },
  { code: '258', name: 'Moçambique', flag: '🇲🇿' },
  { code: '95', name: 'Myanmar', flag: '🇲🇲' },
  { code: '264', name: 'Namíbia', flag: '🇳🇦' },
  { code: '674', name: 'Nauru', flag: '🇳🇷' },
  { code: '977', name: 'Nepal', flag: '🇳🇵' },
  { code: '31', name: 'Holanda', flag: '🇳🇱' },
  { code: '64', name: 'Nova Zelândia', flag: '🇳🇿' },
  { code: '505', name: 'Nicarágua', flag: '🇳🇮' },
  { code: '227', name: 'Níger', flag: '🇳🇪' },
  { code: '234', name: 'Nigéria', flag: '🇳🇬' },
  { code: '47', name: 'Noruega', flag: '🇳🇴' },
  { code: '968', name: 'Omã', flag: '🇴🇲' },
  { code: '92', name: 'Paquistão', flag: '🇵🇰' },
  { code: '680', name: 'Palau', flag: '🇵🇼' },
  { code: '507', name: 'Panamá', flag: '🇵🇦' },
  { code: '595', name: 'Paraguai', flag: '🇵🇾' },
  { code: '51', name: 'Peru', flag: '🇵🇪' },
  { code: '63', name: 'Filipinas', flag: '🇵🇭' },
  { code: '48', name: 'Polónia', flag: '🇵🇱' },
  { code: '351', name: 'Portugal', flag: '🇵🇹' },
  { code: '974', name: 'Catar', flag: '🇶🇦' },
  { code: '40', name: 'Roménia', flag: '🇷🇴' },
  { code: '7', name: 'Rússia', flag: '🇷🇺' },
  { code: '250', name: 'Ruanda', flag: '🇷🇼' },
  { code: '590', name: 'Saint-Barthélemy', flag: '🇧🇱' },
  { code: '685', name: 'Samoa', flag: '🇼🇸' },
  { code: '378', name: 'San Marino', flag: '🇸🇲' },
  { code: '239', name: 'São Tomé e Príncipe', flag: '🇸🇹' },
  { code: '966', name: 'Arábia Saudita', flag: '🇸🇦' },
  { code: '221', name: 'Senegal', flag: '🇸🇳' },
  { code: '381', name: 'Sérvia', flag: '🇷🇸' },
  { code: '248', name: 'Seicheles', flag: '🇸🇨' },
  { code: '232', name: 'Serra Leoa', flag: '🇸🇱' },
  { code: '65', name: 'Singapura', flag: '🇸🇬' },
  { code: '421', name: 'Eslováquia', flag: '🇸🇰' },
  { code: '386', name: 'Eslovénia', flag: '🇸🇮' },
  { code: '677', name: 'Ilhas Salomão', flag: '🇸🇧' },
  { code: '252', name: 'Somália', flag: '🇸🇴' },
  { code: '27', name: 'África do Sul', flag: '🇿🇦' },
  { code: '82', name: 'Coreia do Sul', flag: '🇰🇷' },
  { code: '211', name: 'Sudão do Sul', flag: '🇸🇸' },
  { code: '34', name: 'Espanha', flag: '🇪🇸' },
  { code: '94', name: 'Sri Lanka', flag: '🇱🇰' },
  { code: '249', name: 'Sudão', flag: '🇸🇩' },
  { code: '597', name: 'Suriname', flag: '🇸🇷' },
  { code: '268', name: 'Suazilândia', flag: '🇸🇿' },
  { code: '46', name: 'Suécia', flag: '🇸🇪' },
  { code: '41', name: 'Suíça', flag: '🇨🇭' },
  { code: '963', name: 'Síria', flag: '🇸🇾' },
  { code: '886', name: 'Taiwan', flag: '🇹🇼' },
  { code: '992', name: 'Tajiquistão', flag: '🇹🇯' },
  { code: '255', name: 'Tanzânia', flag: '🇹🇿' },
  { code: '66', name: 'Tailândia', flag: '🇹🇭' },
  { code: '670', name: 'Timor-Leste', flag: '🇹🇱' },
  { code: '228', name: 'Togo', flag: '🇹🇬' },
  { code: '676', name: 'Tonga', flag: '🇹🇴' },
  { code: '1868', name: 'Trinidade e Tobago', flag: '🇹🇹' },
  { code: '216', name: 'Tunísia', flag: '🇹🇳' },
  { code: '90', name: 'Turquia', flag: '🇹🇷' },
  { code: '993', name: 'Turquemenistão', flag: '🇹🇲' },
  { code: '688', name: 'Tuvalu', flag: '🇹🇻' },
  { code: '256', name: 'Uganda', flag: '🇺🇬' },
  { code: '380', name: 'Ucrânia', flag: '🇺🇦' },
  { code: '971', name: 'Emirados Árabes Unidos', flag: '🇦🇪' },
  { code: '44', name: 'Reino Unido', flag: '🇬🇧' },
  { code: '1', name: 'Estados Unidos', flag: '🇺🇸' },
  { code: '598', name: 'Uruguai', flag: '🇺🇾' },
  { code: '998', name: 'Uzbequistão', flag: '🇺🇿' },
  { code: '678', name: 'Vanuatu', flag: '🇻🇺' },
  { code: '39', name: 'Vaticano', flag: '🇻🇦' },
  { code: '58', name: 'Venezuela', flag: '🇻🇪' },
  { code: '84', name: 'Vietname', flag: '🇻🇳' },
  { code: '967', name: 'Iémen', flag: '🇾🇪' },
  { code: '260', name: 'Zâmbia', flag: '🇿🇲' },
  { code: '263', name: 'Zimbábue', flag: '🇿🇼' }
];

// Remover duplicados mantendo Portugal primeiro
const uniqueMap = new Map();
COUNTRIES.forEach(country => {
  if (!uniqueMap.has(country.code) || country.code === '351') {
    uniqueMap.set(country.code, country);
  }
});

// Ordenar: Portugal primeiro, depois por código do indicativo (menor para maior)
export const UNIQUE_COUNTRIES = Array.from(uniqueMap.values()).sort((a, b) => {
  // Portugal sempre primeiro
  if (a.code === '351' && b.code !== '351') return -1;
  if (a.code !== '351' && b.code === '351') return 1;
  
  // Converter códigos para números para ordenar corretamente
  // Códigos de 1-3 dígitos: converter para número
  const codeA = parseInt(a.code, 10);
  const codeB = parseInt(b.code, 10);
  
  // Se ambos são números válidos, ordenar numericamente
  if (!isNaN(codeA) && !isNaN(codeB)) {
    return codeA - codeB;
  }
  
  // Fallback: ordenar alfabeticamente se não for número
  return a.code.localeCompare(b.code);
});

